module.exports = __webpack_public_path__ + "img/MistyThePogged.d8cbf750.png";